webpackJsonp([53162433187081],{

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.languageOverviewScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scxml = __webpack_require__(28);
	
	var _scxml2 = _interopRequireDefault(_scxml);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _languageOverviewPanel = __webpack_require__(409);
	
	var _languageOverviewPanel2 = _interopRequireDefault(_languageOverviewPanel);
	
	var _languageOverview = __webpack_require__(904);
	
	var _languageOverview2 = _interopRequireDefault(_languageOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.languageOverviewScxml = _languageOverview2.default;
	
	var W3CLanguageOverviewExample = function (_React$Component) {
	  _inherits(W3CLanguageOverviewExample, _React$Component);
	
	  function W3CLanguageOverviewExample(props) {
	    _classCallCheck(this, W3CLanguageOverviewExample);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.timeouts = {};
	    _this.state = {
	      log: []
	    };
	    return _this;
	  }
	
	  W3CLanguageOverviewExample.prototype.componentDidMount = function componentDidMount() {
	    this.start();
	  };
	
	  W3CLanguageOverviewExample.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelAll();
	  };
	
	  W3CLanguageOverviewExample.prototype.start = function start() {
	    var _this2 = this;
	
	    this.cancelAll();
	    this.setState({ log: [] });
	
	    _scxml2.default.documentStringToModel(null, _languageOverview2.default, function (err, model) {
	      if (err) throw err;
	      model.prepare(function (err, modelFactory) {
	        if (err) throw err;
	
	        _this2.sc = new _scxml2.default.scion.Statechart(modelFactory, {
	          customSend: _this2.customSend.bind(_this2),
	          customCancel: _this2.customCancel.bind(_this2)
	        });
	
	        var transitionsEnabled = void 0;
	        _this2.sc.on('onBigStepBegin', function () {
	          transitionsEnabled = new Map();
	        });
	        _this2.sc.on('onBigStepEnd', function () {
	          var _sc$getSnapshot = _this2.sc.getSnapshot(),
	              _ = _sc$getSnapshot[0],
	              history = _sc$getSnapshot[1],
	              isInFinalState = _sc$getSnapshot[2],
	              datamodel = _sc$getSnapshot[3];
	
	          _this2.setState({
	            datamodel: datamodel,
	            configuration: _this2.sc.getFullConfiguration(),
	            transitionsEnabled: transitionsEnabled
	          });
	        });
	        _this2.sc.on('onTransition', function (transitionSourceId, targetIds, transitionIndex) {
	          if (transitionsEnabled.has(transitionSourceId)) {
	            transitionsEnabled.get(transitionSourceId).add(transitionIndex);
	          } else {
	            transitionsEnabled.set(transitionSourceId, new Set([transitionIndex]));
	          }
	        });
	        _this2.sc.start();
	      });
	    });
	  };
	
	  W3CLanguageOverviewExample.prototype.customSend = function customSend(event, options) {
	    var _this3 = this;
	
	    var send = function send() {
	      if (event.name === 'trace') {
	        _this3.appendLog(event.data);
	      } else if (event.name.indexOf('external.') === 0) {
	        _this3.appendLog('' + event.name + (event.data ? ' ' + JSON.stringify(event.data) : ''));
	      } else {
	        _this3.sc.gen(event);
	      }
	    };
	
	    if (options && options.delay) {
	      this.timeouts[event.sendid] = setTimeout(send, options.delay);
	    } else {
	      send();
	    }
	  };
	
	  W3CLanguageOverviewExample.prototype.customCancel = function customCancel(sendid) {
	    clearTimeout(this.timeouts[sendid]);
	    delete this.timeouts[sendid];
	  };
	
	  W3CLanguageOverviewExample.prototype.cancelAll = function cancelAll() {
	    var _this4 = this;
	
	    Object.keys(this.timeouts).forEach(function (sendid) {
	      return _this4.customCancel(sendid);
	    });
	  };
	
	  W3CLanguageOverviewExample.prototype.appendLog = function appendLog(entry) {
	    if (!entry) return;
	    this.setState(function (_ref) {
	      var log = _ref.log;
	      return { log: log.concat(entry).slice(-12) };
	    });
	  };
	
	  W3CLanguageOverviewExample.prototype.send = function send(event) {
	    if (this.sc) this.sc.gen(event);
	  };
	
	  W3CLanguageOverviewExample.prototype.reset = function reset() {
	    this.start();
	  };
	
	  W3CLanguageOverviewExample.prototype.render = function render() {
	    var _this5 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row', style: { minHeight: '620px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-8', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '620px', width: '100%', position: 'relative', border: '1px solid #eee' } },
	          _react2.default.createElement(_schviz2.default, {
	            scxmlDocumentString: _languageOverview2.default,
	            disableAnimation: true,
	            configuration: this.state && this.state.configuration,
	            disableZoomAnimation: true,
	            transitionsEnabled: this.state && this.state.transitionsEnabled,
	            expandAllStatesByDefault: true,
	            layoutOptions: _schviz2.default.layouts.auto,
	            id: 'w3c-language-overview'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-4', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '620px', border: '1px solid #eee' } },
	          _react2.default.createElement(_languageOverviewPanel2.default, {
	            configuration: this.state.configuration,
	            log: this.state.log,
	            onEvent: function onEvent(event) {
	              return _this5.send(event);
	            },
	            onReset: function onReset() {
	              return _this5.reset();
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return W3CLanguageOverviewExample;
	}(_react2.default.Component);
	
	exports.default = W3CLanguageOverviewExample;

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var steps = [{
	  state: 'Test1Sub1',
	  title: 'Basic transition',
	  description: 'Dispatch Event1 to leave the first atomic substate and complete Test1.',
	  event: 'Event1',
	  label: 'Send Event1'
	}, {
	  state: 'Test2Sub1',
	  title: 'Included substate',
	  description: 'Dispatch Event2 to complete the inlined external substate example.',
	  event: 'Event2',
	  label: 'Send Event2'
	}, {
	  state: 'Test3Sub1',
	  title: 'Delayed send',
	  description: 'A Timer event is scheduled for five seconds after entering this state.',
	  event: 'Timer',
	  label: 'Fire Timer now'
	}, {
	  state: 'Dialing',
	  title: 'External event',
	  description: 'The chart sent a create-call request. Confirm that the connection is established.',
	  event: 'external.connected',
	  label: 'Connected'
	}, {
	  state: 'Prompting',
	  title: 'Prompt callback',
	  description: 'The prompt step is waiting for an external completion event.',
	  event: 'external.prompt.done',
	  label: 'Prompt done'
	}, {
	  state: 'StartingSecondForm',
	  title: 'Second form',
	  description: 'The chart requested a second form. Complete that external interaction.',
	  event: 'external.second.done',
	  label: 'Second form done'
	}, {
	  state: 'Disconnecting',
	  title: 'Disconnect',
	  description: 'The chart requested a disconnect. Confirm the final external event.',
	  event: 'external.disconnected',
	  label: 'Disconnected'
	}];
	
	var LanguageOverviewPanel = function LanguageOverviewPanel(_ref) {
	  var configuration = _ref.configuration,
	      log = _ref.log,
	      onEvent = _ref.onEvent,
	      onReset = _ref.onReset;
	
	  var states = configuration || [];
	  var activeStep = steps.find(function (step) {
	    return states.indexOf(step.state) > -1;
	  });
	  var isDone = states.indexOf('Done') > -1;
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', padding: '1rem', background: '#f7f7f7', overflow: 'auto' } },
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'div',
	        { style: { color: '#666', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.08em' } },
	        'Active flow'
	      ),
	      _react2.default.createElement(
	        'h3',
	        { style: { margin: '0.25rem 0' } },
	        isDone ? 'Done' : activeStep ? activeStep.title : 'Advancing'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { minHeight: '3rem', marginBottom: 0 } },
	        isDone ? 'The wrapper state reached its final child state.' : activeStep && activeStep.description
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '1rem' } },
	      activeStep && _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary', style: { marginRight: '0.5rem' }, onClick: function onClick() {
	            return onEvent(activeStep.event);
	          } },
	        activeStep.label
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-light', onClick: onReset },
	        'Reset'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Configuration'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexWrap: 'wrap', marginTop: '0.5rem' } },
	        states.map(function (state) {
	          return _react2.default.createElement(
	            'span',
	            {
	              key: state,
	              style: {
	                background: '#fff',
	                border: '1px solid #ddd',
	                borderRadius: '2px',
	                padding: '0.25rem 0.45rem',
	                margin: '0 0.35rem 0.35rem 0',
	                fontFamily: 'monospace',
	                fontSize: '0.85rem'
	              }
	            },
	            state
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Trace'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { marginTop: '0.5rem', fontFamily: 'monospace', fontSize: '0.85rem' } },
	        (log || []).map(function (entry, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: entry + '-' + index, style: { padding: '0.35rem 0', borderTop: index ? '1px solid #e2e2e2' : 0 } },
	            entry
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = LanguageOverviewPanel;
	module.exports = exports['default'];

/***/ }),

/***/ 904:
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"us-ascii\"?>\n<scxml xmlns=\"http://www.w3.org/2005/07/scxml\"\n       version=\"1.0\"\n       initial=\"Main\"\n       datamodel=\"ecmascript\">\n  <state id=\"Main\" initial=\"Test1\">\n    <state id=\"Test1\" initial=\"Test1Sub1\">\n      <onentry>\n        <send event=\"trace\">\n          <content expr=\"'Inside Test1'\"/>\n        </send>\n      </onentry>\n\n      <state id=\"Test1Sub1\">\n        <onentry>\n          <send event=\"trace\">\n            <content expr=\"'Inside Test1Sub1'\"/>\n          </send>\n        </onentry>\n        <onexit>\n          <send event=\"trace\">\n            <content expr=\"'Leaving Test1Sub1'\"/>\n          </send>\n        </onexit>\n        <transition event=\"Event1\" target=\"Test1Sub2\"/>\n      </state>\n\n      <final id=\"Test1Sub2\"/>\n\n      <transition event=\"done.state.Test1\" target=\"Test2\"/>\n\n      <onexit>\n        <send event=\"trace\">\n          <content expr=\"'Leaving Test1'\"/>\n        </send>\n      </onexit>\n    </state>\n\n    <state id=\"Test2\" initial=\"Test2Sub1\">\n      <state id=\"Test2Sub1\">\n        <onentry>\n          <send event=\"trace\">\n            <content expr=\"'Inside Test2Sub1'\"/>\n          </send>\n        </onentry>\n        <transition event=\"Event2\" target=\"Test2Sub2\"/>\n      </state>\n\n      <final id=\"Test2Sub2\"/>\n      <transition event=\"done.state.Test2\" target=\"Test3\"/>\n    </state>\n\n    <state id=\"Test3\" initial=\"Test3Sub1\">\n      <state id=\"Test3Sub1\">\n        <onentry>\n          <send event=\"trace\">\n            <content expr=\"'Inside Test3Sub1; waiting for Timer'\"/>\n          </send>\n          <send event=\"Timer\" delay=\"5s\" id=\"Timer\"/>\n        </onentry>\n        <transition event=\"Timer\" target=\"Test4\"/>\n        <onexit>\n          <send event=\"trace\">\n            <content expr=\"'Leaving Test3Sub1'\"/>\n          </send>\n        </onexit>\n      </state>\n\n      <onexit>\n        <send event=\"trace\">\n          <content expr=\"'Leaving Test3'\"/>\n        </send>\n      </onexit>\n    </state>\n\n    <state id=\"Test4\" initial=\"Test4Sub1\">\n      <onentry>\n        <send event=\"trace\">\n          <content expr=\"'Inside Test4'\"/>\n        </send>\n      </onentry>\n\n      <state id=\"Test4Sub1\">\n        <onexit>\n          <send event=\"trace\">\n            <content expr=\"'Leaving Test4Sub1'\"/>\n          </send>\n        </onexit>\n        <transition target=\"Test5\"/>\n      </state>\n    </state>\n\n    <state id=\"Test5\" initial=\"Test5P\">\n      <onentry>\n        <send event=\"trace\">\n          <content expr=\"'Inside Test5; entering parallel state'\"/>\n        </send>\n      </onentry>\n\n      <parallel id=\"Test5P\">\n        <state id=\"Test5PSub1\" initial=\"Test5PSub1Final\">\n          <final id=\"Test5PSub1Final\"/>\n        </state>\n        <state id=\"Test5PSub2\" initial=\"Test5PSub2Final\">\n          <final id=\"Test5PSub2Final\"/>\n        </state>\n        <onexit>\n          <send event=\"trace\">\n            <content expr=\"'All parallel states done'\"/>\n          </send>\n        </onexit>\n      </parallel>\n\n      <transition event=\"done.state.Test5P\" target=\"Test6\"/>\n    </state>\n\n    <state id=\"Test6\" initial=\"Dialing\">\n      <datamodel>\n        <data id=\"dest\" expr=\"'tel:+18315552020'\"/>\n        <data id=\"src\" expr=\"'helloworld2.vxml'\"/>\n        <data id=\"formid\" expr=\"'HelloWorld'\"/>\n      </datamodel>\n\n      <state id=\"Dialing\">\n        <onentry>\n          <send event=\"external.createcall\">\n            <content expr=\"dest\"/>\n          </send>\n        </onentry>\n        <transition event=\"external.connected\" target=\"Prompting\"/>\n      </state>\n\n      <state id=\"Prompting\">\n        <onentry>\n          <send event=\"external.prompt\">\n            <content expr=\"'Hello World!'\"/>\n          </send>\n        </onentry>\n        <transition event=\"external.prompt.done\" target=\"StartingSecondForm\"/>\n      </state>\n\n      <state id=\"StartingSecondForm\">\n        <onentry>\n          <send event=\"external.formstart\">\n            <content expr=\"{src: src, id: formid}\"/>\n          </send>\n        </onentry>\n        <transition event=\"external.second.done\" target=\"Disconnecting\"/>\n      </state>\n\n      <state id=\"Disconnecting\">\n        <onentry>\n          <send event=\"external.disconnect\"/>\n        </onentry>\n        <transition event=\"external.disconnected\" target=\"Done\"/>\n      </state>\n\n      <transition event=\"send.failed\" target=\"Done\">\n        <send event=\"trace\">\n          <content expr=\"'External component failed'\"/>\n        </send>\n      </transition>\n\n      <onexit>\n        <send event=\"trace\">\n          <content expr=\"'Finished with external component'\"/>\n        </send>\n      </onexit>\n    </state>\n\n    <final id=\"Done\"/>\n  </state>\n</scxml>\n"

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _prismjs = __webpack_require__(38);
	
	var _prismjs2 = _interopRequireDefault(_prismjs);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _w3cLanguageOverviewExample = __webpack_require__(408);
	
	var _w3cLanguageOverviewExample2 = _interopRequireDefault(_w3cLanguageOverviewExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var LanguageOverview = function LanguageOverview(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'This ports the W3C SCXML Language Overview into a runnable browser example. The external include is inlined, and the external CCXML/VoiceXML portion is represented by browser-driven events so the whole flow can run in SCION.'
	    ),
	    React.createElement(_w3cLanguageOverviewExample2.default, null),
	    React.createElement(
	      'h2',
	      null,
	      'SCXML source'
	    ),
	    React.createElement(
	      _reactPrism2.default,
	      { component: 'pre', className: 'language-xml' },
	      _w3cLanguageOverviewExample.languageOverviewScxml
	    )
	  );
	};
	
	var WrappedLanguageOverview = function WrappedLanguageOverview(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: LanguageOverview, pathname: location.pathname });
	};
	
	exports.default = WrappedLanguageOverview;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-examples-language-overview-js-6dd354eae0bece0676eb.js